import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { NavLinks } from "./NavLinks";
import { Session } from "@supabase/supabase-js";

interface MobileNavProps {
  session: Session | null;
  handleAuthClick: () => void;
}

export const MobileNav = ({ session, handleAuthClick }: MobileNavProps) => {
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="text-white">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent
        side="left"
        className="w-[300px] bg-skuhub-navy/90 backdrop-blur-lg border-skuhub-navy"
      >
        <div className="flex flex-col gap-6 mt-6">
          <NavLinks session={session} handleAuthClick={handleAuthClick} />
        </div>
      </SheetContent>
    </Sheet>
  );
};